import S from 'common/service/sanctuary';
import { has, intersperse } from 'ramda';
import { createSelector } from 'reselect';

import * as criteriaSelectors from './criteria/selectors';

const getCriteria$ = S.prop('criteria');

const isExpanded = S.prop('expanded');

const hasCriteria = createSelector(
  getCriteria$,
  criteria => property => has(property, criteria),
);

const getCriteriaState = createSelector(
  getCriteria$,
  criteria => property => S.get(
    S.is(Object),
    property,
    criteria,
  ),
);

const getCriteria = createSelector(
  getCriteria$,
  S.compose(
    S.filter(criteriaSelectors.hasConstraints),
    S.values,
  ),
);

const getCount = createSelector(
  getCriteria,
  S.prop('length'),
);

export const toDSL = S.pipe([
  S.map(criteriaSelectors.toDSL),
  S.justs,
  S.map(criteria => `(${criteria})`),
  criteria => (criteria.length
    ? S.Just(S.unwords(intersperse('and', criteria)))
    : S.Nothing
  ),
]);

const getDSL = createSelector(
  getCriteria,
  toDSL,
);

const hasConstraints = createSelector(
  getCriteriaState,
  getState => property => S.maybe(
    false,
    criteriaSelectors.hasConstraints,
    getState(property),
  ),
);

export const factory = getScope => ({
  isExpanded: createSelector(
    getScope,
    isExpanded,
  ),
  hasCriteria: createSelector(
    getScope,
    hasCriteria,
  ),
  getCriteriaState: createSelector(
    getScope,
    getCriteriaState,
  ),
  getCriteria: createSelector(
    getScope,
    getCriteria,
  ),
  getCount: createSelector(
    getScope,
    getCount,
  ),
  getDSL: createSelector(
    getScope,
    getDSL,
  ),
  hasConstraints: createSelector(
    getScope,
    hasConstraints,
  ),
});

export default factory;
